export interface Company {
  id?: number;
  name: string;
  companyType: string;
  industry?: string;
  location?: string;
  recruitmentUrl: string;
  notes?: string;
  isStarred: boolean;
  isPinned: boolean;
  status: CompanyStatus;
  contactPerson?: string;
  createTime?: string;
  updateTime?: string;
  positionCount?: number;
  resourceCount?: number;
}

export type CompanyStatus = 
  | 'planned'     // 计划投递
  | 'submitted'   // 已投递
  | 'interviewing' // 面试中
  | 'offered'     // 收到offer
  | 'rejected'    // 已拒绝
  | 'accepted';   // 已接受

export interface CompanyQueryParams {
  companyType?: string;
  status?: CompanyStatus;
  isStarred?: boolean;
  isPinned?: boolean;
  page?: number;
  size?: number;
}

export interface CompanySearchParams {
  keyword: string;
  page?: number;
  size?: number;
}

export const COMPANY_STATUS_MAP = {
  planned: '计划投递',
  submitted: '已投递',
  interviewing: '面试中',
  offered: '收到offer',
  rejected: '已拒绝',
  accepted: '已接受'
};

export const COMPANY_STATUS_COLOR_MAP = {
  planned: '#909399',      // 灰色
  submitted: '#409EFF',    // 蓝色
  interviewing: '#E6A23C', // 黄色
  offered: '#67C23A',      // 绿色
  rejected: '#F56C6C',     // 红色
  accepted: '#67C23A'      // 绿色
};

export const COMPANY_TYPE_OPTIONS = [
  { label: '大厂', value: '大厂' },
  { label: '中厂', value: '中厂' },
  { label: '小厂', value: '小厂' },
  { label: '外企', value: '外企' },
  { label: '国企', value: '国企' },
  { label: '央企', value: '央企' },
  { label: '创业公司', value: '创业公司' },
  { label: '其他', value: '其他' }
];

export const INDUSTRY_OPTIONS = [
  { label: '互联网', value: '互联网' },
  { label: '金融', value: '金融' },
  { label: '教育', value: '教育' },
  { label: '医疗健康', value: '医疗健康' },
  { label: '制造业', value: '制造业' },
  { label: '能源', value: '能源' },
  { label: '房地产', value: '房地产' },
  { label: '零售', value: '零售' },
  { label: '电子商务', value: '电子商务' },
  { label: '人工智能', value: '人工智能' },
  { label: '其他', value: '其他' }
]; 